/**
 * mcycle protocol module
 * @Create jiangbao(jiangbao1123@gmail.com)
 * @CreateDate  2017/12/20
 */
import './index.css';
import React from 'react';

const Protocol = () => {
  return <div className="mcycle-protocol-page">
    <h1>回购协议</h1>
    <p>在您使用魅族mCycle项目回收服务前，敬请您全面仔细审阅协议中的内容，协议内容已经明确您享受的权益，以下规则所述事项：</p>
    <p>1. 回收企业是根据您机器实际情况确认回收价格，请您如实描述自己电子产品的相应情况。若您的电子产品与描述有差异或不符，回收企业将通知您机器差异情况，并根据实际情况，重新评价。您也可以取消本次交易，申请退货。</p>
    <p>2. 用户坚持按照出现明显输入错误或依据常识不可能被认为是真实价格的价格出售物品。魅族公司与回收企业有权取消或终止此类价格错误的订单。</p>
    <p>3. 回收系统评估价格会有实时调整和变化，订单提交7个自然日内保护回收价格不变动，超时则按照最新的网站价格进行评估。</p>
    <p>4. 官方评估系统价格调整不做通知，以提交订单时为准。</p>
    <p>5. 24 小时承诺不包括以下情况：手机软件故障需刷机、需解密码、无法联系上用户、已申请进一步检测、法定节假日顺延、用户本身原因等，此类情况将根据实际情况确定返回收金时间。</p>
    <p>6. 您在交付交易物品前，应自行确保已对物品内的重要资料进行了备份和清除（包括但不限于通讯录、信息、聊天软件的账号用户名、密码、聊天记录、照片、视频、音频等）。如因您未执行此操作导致您资料损失和/或个人信息泄露的，一切责任及后果将由您自行承担，回收企业无需承担任何责任; 若您的SIM卡/内存卡随机器一起回收，回收企业为了保障您的信息安全将会对其进行销毁处理。
回收企业将对交易物品内存储的信息穷尽已有的技术手段进行最终消除的有效处理。如非因回收企业的原因，交易物品内的相关信息确实无法完全消除的，回收企业不承担任何责任。
质检过程中为了准确检测机器属性，需要打开部分iPhone手机的屏幕前盖或后盖，确认机器是否存在进水和拆修等情况，不会对机器造成功能影响。对于贴膜机器，回收企业会对机器进行撕膜质检。</p>
    <p>7. 物品回收交易成功完成之后，回收企业有权对物品进行处理，对物品不做保留和预留，请自行保留无关配件及凭证。</p>
    <p>8. 建议您选择顺丰快递到付寄出您需要回收机器，如果交易取消，机器金额 50 元以上回收企业会承担退回邮费，50 元以下将由用户自行承担。</p>
    <p>9. 本交易秉承合法、公平、透明、合理的原则进行。</p>
    <p>10. 交易物品需为正规渠道物品，您应保证对交易物品拥有合法、完整的处分权利。如回收企业发现您提交的物品为非法渠道物品，回收企业有权退回或予警处理，回收企业不承担其责任。</p>
    <p>11. 山寨机、高仿机、非法渠道物品，回收企业拒绝回收，并有权退回或予警处理，回收企业不承担其责任，且退回产生物流费由用户自行承担。</p>
    <p>12. 如客户设备有密码，但无法提供，如退货用户需承担来回运费。</p>
    <p>13. 若卖家物品在快递签收前，遭遇第三方快递公司的损坏、丢失或者其它任何的利益损害，魅族公司与回收企业将不承担任何责任和损失。</p>
    <p>14. 您选择邮寄交易方式的，应在提交订单后尽快将物品邮寄至回收企业指定地址。由于您未及时寄出物品导致订单取消的，魅族公司与回收企业将不承担任何责任。</p>
    <p>15. 使用回收金购物产生的退货，退款金额将原路返回，系统优先返还回收金支付金额。即回收金支付的部分金额退还至原有回收金，现金支付的部分金额退还至原有银行卡或者支付宝。</p>
    <p>16. 您应承诺与保证所交付的交易物品均来源合法，不存在任何被执法机关追索、或任意第三方提出权利主张的情形。如因您所交付的交易物品来源不合法而需承担任何法律责任的，均由您自行承担，如魅族或回收企业因执法机关要求或任何第三方主张而先行垫付或赔付款项、或发生其他任何支出的，您应全额向魅族或回收企业予以赔偿。先行垫付的行为不代表对您赔偿责任的豁免，也不能视为与您共同承担法律责任的默示。</p>
    <p>17. 对于无人认领且回收企业通过物流单据和订单信息无法联系到物主的产品设备（下称“无主物”），自回收企业签收该无主物之日起，将免费保管30日。超过30日仍然无人认领的，回收企业将按照5元每日向物主计收保管费直至无主物被转售或环保处理，或被物主认领。回收企业保管无主物期间，非因回收企业的原因造成的无主物价值减损或灭失的，由物主自行承担不利后果。</p>
  </div>
}

export default Protocol



// WEBPACK FOOTER //
// ./src/components/protocol/index.js